// Website analytics: our self-hosted PostHog (2026-10-11), reached through Caddy's /ph ingestion proxy on
// helibrain.com (hb_infra roles/posthog). Next.js runs this file in the browser before the app starts.
//
// Normal posthog-js persistence (2026-10-11): an anonymous visitor ID in a first-party cookie + localStorage,
// so returning visitors are recognised across days and PostHog's GeoIP adds the country. Cookieless mode
// was tried first and dropped: it discards the IP before GeoIP runs and resets visitors daily, and the
// site already sets other analytics cookies through Google Tag Manager.
//
// The project keys are public, write-only SDK keys. The key is picked by hostname, so the stage site
// reports to the stage project and local dev (localhost) sends nothing.
import posthog from "posthog-js";
import { scrubPostHogException, startWebsiteErrorLogging } from "./lib/websiteErrors";
import { onInteractionPlaying } from "./lib/testInteractions";
import { isEmbedPage } from "./lib/embed";

startWebsiteErrorLogging();

const PROJECT_KEYS: Record<string, string> = {
  "helibrain.com": "phc_whKBVuY9nqW5kZRRMpkjpsaYFNqJvLPjjnBmYJQZQCRU",
  "helibrain.duckdns.org": "phc_BUjFWnXFVyEuaeQUthkS7SxrnNYXu3e34MC2AaJaz8wP",
  // Robert's dev_robert instance on the stage box reports to the stage project too.
  "dev-robert.helibrain.duckdns.org": "phc_BUjFWnXFVyEuaeQUthkS7SxrnNYXu3e34MC2AaJaz8wP",
};

const projectKey = PROJECT_KEYS[window.location.hostname];

if (projectKey) {
  posthog.init(projectKey, {
    api_host: "https://helibrain.com/ph",
    defaults: "2026-05-30",
    // Returning visitors and account linking (2026-11-03), spelled out so an SDK default change can't undo them:
    // the visitor id lives in a cookie (365 days) plus localStorage; the cookie is set on the site domain
    // (.helibrain.com), so the web app's sign-in calls to helibrain.com carry it and the gateway joins the
    // visitor to the new account (routers/auth/website_visitor.py). The cookie also keeps the first referrer
    // and landing URL ($initial_person_info).
    persistence: "localStorage+cookie",
    cross_subdomain_cookie: true,
    cookie_expiration: 365,
    disable_session_recording: true,
    // Sentry owns website errors; remote analytics settings cannot turn on a second collector.
    capture_exceptions: false,
    error_tracking: { exception_steps: { enabled: false } },
    before_send: scrubPostHogException,
    capture_performance: false,
    enable_heatmaps: false,
    capture_dead_clicks: false,
    rageclick: false,
    // Not used, and Caddy's /ph proxy forwards only ingestion paths, so their lazy-loaded scripts under /ph/static 404.
    disable_surveys: true,
    disable_product_tours: true,
    disable_conversations: true,
  });
  const autocapture = posthog.config.autocapture;
  onInteractionPlaying(playing => {
    // V1.13 records the game itself. Avoid PostHog's DOM traversal on timed clicks;
    // keep ordinary click autocapture before/after the run and preserve embed opt-out.
    if (!isEmbedPage()) posthog.set_config({ autocapture: playing ? false : autocapture });
  });
}
